import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-charcoal-900 text-cream/50 py-12 border-t border-charcoal-800" data-id="element-68">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-69">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-70">
          <div className="text-center md:text-left" data-id="element-71">
            <span className="text-xl font-heading font-bold tracking-wider text-cream block mb-1" data-id="element-72">
              MALOSTRANSKÁ
            </span>
            <span className="tracking-[0.3em] text-gold uppercase font-body text-[16px]" data-id="element-73">
              RESIDENCE
            </span>
          </div>

          <div className="text-sm font-light text-center md:text-right" data-id="element-74">
            <p data-id="element-75">&copy; {new Date().getFullYear()} Malostranská Residence.</p>
            <p className="mt-1" data-id="element-76">{t.footer.rights}</p>
          </div>
        </div>
      </div>
    </footer>;
}